import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Navbar, Footer } from './components'
import Routes from './router'
import { ProjectContext } from './context/ProjectContext'

function App() {

  const [projects, setProjects] = useState();
  //const [theme, setTheme] = useState(localStorage.getItem('theme')!== null ? localStorage.getItem('theme') :'dark');

// useEffect(() => {
//   localStorage.setItem('theme', theme);
// },[theme])

  return (
    // <ThemeContext.Provider value={{ theme, setTheme }}>
      <ProjectContext.Provider value={{ projects, setProjects }}>
        <Router>
          <Navbar />
          <Routes />
          <Footer />
        </Router >
      </ProjectContext.Provider>
    //</ThemeContext.Provider>      
  );
}

export default App;
